import { render, staticRenderFns } from "./eliminarRegistro.vue?vue&type=template&id=1bb576fa&scoped=true&lang=html&"
import script from "./eliminarRegistro.vue?vue&type=script&lang=js&"
export * from "./eliminarRegistro.vue?vue&type=script&lang=js&"
import style0 from "./eliminarRegistro.vue?vue&type=style&index=0&id=1bb576fa&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb576fa",
  null
  
)

export default component.exports